export default function ContextAdsWhatIs() {
  return (
    <section id="context-ads-what" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-lightbulb-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Просто о сложном
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Что такое контекстная реклама?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full mb-6"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-justify sm:text-center">
            Контекстная реклама — это маркетинговый инструмент, который показывает ваши объявления тем людям,
            которые{' '}
            <span className="text-[#C5A880] font-bold relative inline-block">
              уже ищут ваш товар или услугу в интернете
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#C5A880] rounded-full"></span>
            </span>
            , либо интересовались вашей тематикой ранее.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-10 sm:mb-14">
          {/* Card 1 — Search */}
          <div className="bg-[#F9F5EF] rounded-2xl sm:rounded-3xl overflow-hidden border border-[#C5A880]/20">
            <div className="h-48 sm:h-64 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/66c922ca9ba681418e663c433e8778d9.jpg"
                alt="Реклама в поиске Яндекс и Google"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1A2B4C] rounded-xl flex-shrink-0">
                  <i className="ri-search-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">
                    На поиске (Яндекс / Google)
                  </h3>
                  <p className="text-[#C5A880] text-xs font-semibold font-['Montserrat']">Горячий спрос</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed font-['Montserrat'] text-justify mb-4">
                Когда человек вводит конкретный запрос — ваше объявление появляется первым. Это прямой,
                горячий контакт с клиентом в момент, когда он готов купить здесь и сейчас.
              </p>
              <div className="flex items-start gap-2 bg-white rounded-xl p-3 border border-[#C5A880]/20">
                <i className="ri-fire-line text-[#C5A880] text-sm mt-0.5 flex-shrink-0"></i>
                <p className="text-xs text-gray-500 font-['Montserrat'] leading-relaxed">
                  Отвечает на прямой, горячий запрос клиента — в нужное время и в нужном месте.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 — Networks */}
          <div className="bg-[#F9F5EF] rounded-2xl sm:rounded-3xl overflow-hidden border border-[#C5A880]/20">
            <div className="h-48 sm:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=multiple%20digital%20devices%20showing%20banner%20ads%20and%20retargeting%20advertisements%20across%20different%20websites%2C%20smartphone%20tablet%20and%20desktop%20computer%20screens%2C%20digital%20advertising%20network%20concept%2C%20warm%20beige%20and%20golden%20tones%2C%20professional%20clean%20photography%2C%20marketing%20technology%20visualization%20with%20subtle%20network%20connections%20overlay&width=800&height=500&seq=context-ads-network-001&orientation=landscape"
                alt="Реклама в сетях РСЯ и КМС"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1A2B4C] rounded-xl flex-shrink-0">
                  <i className="ri-global-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">
                    В рекламных сетях (РСЯ / КМС)
                  </h3>
                  <p className="text-[#C5A880] text-xs font-semibold font-['Montserrat']">Умный охват и ретаргетинг</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed font-['Montserrat'] text-justify mb-4">
                Показывает объявления на тысячах сайтов-партнёров, анализируя профиль пользователя: интересы,
                поведение в сети и даже геолокацию. Кроссплатформенный трекинг отслеживает пользователя
                как со смартфона, так и с рабочего компьютера.
              </p>
              <div className="space-y-2">
                {[
                  '«Догоняет» тех, кто уже посещал ваш сайт (ретаргетинг)',
                  'Анализирует интересы и поведение аудитории',
                  'Охватывает пользователей, проявлявших интерес к вашей тематике',
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2">
                    <div className="w-5 h-5 mt-0.5 rounded-full bg-[#C5A880]/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#C5A880] text-xs"></i>
                    </div>
                    <p className="text-xs text-gray-600 font-['Montserrat'] leading-relaxed">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom accent block */}
        <div className="bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Photo left */}
            <div className="w-full lg:w-80 xl:w-96 flex-shrink-0 relative">
              <img
                src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/6f374b2800f566fcb6845f6eadf3a761.png"
                alt="Ирина Шарова-Ялынпала — эксперт по контекстной рекламе"
                className="w-full h-auto lg:h-full object-cover object-top"
              />
            </div>
            {/* Text right */}
            <div className="flex-1 p-8 sm:p-10 xl:p-14 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-0.5 bg-[#C5A880]/40 rounded-full"></div>
              </div>
              <h3 className="text-xl sm:text-2xl xl:text-3xl font-bold text-white font-['Playfair_Display'] mb-5 leading-snug">
                Главная задача специалиста<br className="hidden sm:block" /> по контекстной рекламе
              </h3>
              <p className="text-white/80 text-sm sm:text-base leading-relaxed font-['Montserrat'] text-justify">
                Решить, <strong className="text-[#C5A880] font-semibold">где, как и кому именно</strong> показывать вашу рекламу,
                чтобы точно попасть в целевую аудиторию и привести реальных клиентов в ваш бизнес.
                Не просто «закупить трафик», а{' '}
                <strong className="text-white font-semibold">выстроить систему, которая приносит прибыль.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
